import { useContext } from 'react';

import { SettingsContext, type SettingsContextType } from '@/providers/SettingsProvider';

export const useSettings = (): SettingsContextType => {
  const ctx = useContext(SettingsContext);
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx === undefined) {
    throw new Error('useSettings used outside of ContextProvider!');
  } else {
    return ctx;
  }
};
